import { render, staticRenderFns } from "./Product2Detail.vue?vue&type=template&id=22c6d59d&scoped=true"
import script from "./Product2Detail.vue?vue&type=script&lang=js"
export * from "./Product2Detail.vue?vue&type=script&lang=js"
import style0 from "./Product2Detail.vue?vue&type=style&index=0&id=22c6d59d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c6d59d",
  null
  
)

export default component.exports